import React, { JSX } from "react";
import { GetHighlightsMapping } from "../helpers/highlightHelpers";
import { Property } from "../types/property-types";
import { LodgingBusiness } from "schema-dts";
import { jsonLdScriptProps } from "react-schemaorg";

export const buildPropertyJsonLd = (property: Property): JSX.Element => {
  if (!property) {
    return <></>;
  }

  const HIGHLIGHTS_MAPPING = GetHighlightsMapping();
  const highlightItems = property.highlights
    ? Object.entries(property.highlights)
        .filter(([key, value]) => key !== "" && value === true) // Check if the value is true
        .map(
          ([key]) =>
            HIGHLIGHTS_MAPPING[key as keyof typeof HIGHLIGHTS_MAPPING].text,
        )
    : [];

  return (
    <script
      {...jsonLdScriptProps<LodgingBusiness>({
        "@context": "https://schema.org",
        "@type": "LodgingBusiness",
        additionalType: "",
        brand: {
          "@type": "Brand",
          name: "Greystar",
        },
        identifier: property.id,
        name: property.name,
        description: property.about?.shortDescription,
        email: property.contact?.email,
        telephone:
          property?.contact?.trackingPhoneNumber ??
          property.contact?.phoneNumber,
        address: {
          "@type": "PostalAddress",
          addressCountry: property.location?.countryCode,
          addressLocality: property.location?.city,
          addressRegion: property.location?.state,
          postalCode: property.location?.postalCode,
          streetAddress: property.location?.address,
        },
        latitude: property.location?.latitude,
        longitude: property.location?.longitude,
        amenityFeature: highlightItems?.map((item) => ({
          "@type": "LocationFeatureSpecification",
          name: item,
          value: true,
        })),
        containsPlace:
          property.floorplans?.map((floorPlan) => ({
            "@type": "Accommodation",
            identifier: floorPlan.id,
            name: floorPlan.label,
            numberOfBedrooms: floorPlan.bedroomCount,
            numberOfBathroomsTotal: floorPlan.bathroomCount,
            image: floorPlan.imageUrl,
          })) ?? [],
        image: property.imageGallery?.map((image) => image.url) ?? [],
      })}
    />
  );
};
